import { ProductDto } from "../Product"
import { productQohAdjustment } from "../Types"
import { PRODUCT_ACTION_TYPES } from "./index"
import { InventoryData } from "../../inventory/data/model/inventoryData"
import { PatchPayload } from "../service/types"

export const Action = {
    set(payload: ProductDto) {
        return {
            type: PRODUCT_ACTION_TYPES.SET,
            payload: payload
        }
    },

    patch(payload: PatchPayload) {
        return {
            type: PRODUCT_ACTION_TYPES.PATCH,
            payload: payload
        }
    },

    clear() {
        return {
            type: PRODUCT_ACTION_TYPES.CLEAR,
        }
    },

    generateQohAdjustment: (payload: productQohAdjustment) => {
        return {
            type: PRODUCT_ACTION_TYPES.GENERATE_QUANTITY_ON_HAND_ADJUSTMENT,
            payload: payload,
        }
    },

    setInventoryData(payload: InventoryData) {
        return {
            type: PRODUCT_ACTION_TYPES.SET_INVENTORY_DATA,
            payload: payload,
        }
    }
}



// WEBPACK FOOTER //
// ./src/state/product/actions/actions.ts